export const config = {
  title: "Javi's Painting | Residential & Commercial Painting in Indianapolis, IN",
  meta: {
    description:
      "Javi's Painting provides professional interior and exterior painting for homes and businesses across Indianapolis, IN. We specialize in drywall repair, staining, and more.",
    keywords: [
      "Javi's Painting",
      "Indianapolis Painter",
      "Interior Painting",
      "Exterior Painting",
      "Residential Painting",
      "Commercial Painting",
      "Drywall Repair",
      "Deck Staining",
    ],
    author: "Javi's Painting",
    canonicalUrl: 'https://www.javispainting.net/',
  },
  sections: {
    header: {
      businessName: "Javi's Painting",
    },
    sectionB: {
      heroTitle: "Javi's Painting",
      heroSubtitle: 'Quality Painting Services in Indianapolis, IN',
      learnAboutText: 'Explore Our Painting Solutions',
      phoneNumber: '5747039621',
      phoneLabel: '(574) 703-9621',
      heroBackgroundImage:
        'https://static.wixstatic.com/media/1309d5_050e820ff4054829a89b1cc77797e6fe~mv2.jpg/v1/fill/w_980,h_452,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/1309d5_050e820ff4054829a89b1cc77797e6fe~mv2.jpg',
      cardData: [
        {
          title: 'Interior Painting',
          description:
            'We bring fresh color and precision to your walls, ceilings, trim, and more—leaving your home beautiful inside and out.',
        },
        {
          title: 'Exterior Painting',
          description:
            'Weather-resistant, long-lasting exterior paint applications that protect and enhance your property.',
        },
        {
          title: 'Reliable & Local',
          description:
            'Locally owned and operated, Javi’s Painting serves the Indianapolis area with trust and transparency.',
        },
      ],
      description:
        "With over 20 years of experience, Javi's Painting offers expert painting for residential and commercial spaces in Indianapolis, IN. Whether it’s walls, fences, or decks—we bring your vision to life.",
    },
    sectionC: {
      servicesTitle: 'Our Painting Services',
      servicesDescription:
        'Javi’s Painting offers a complete range of painting solutions with a focus on craftsmanship and long-lasting finishes.',
      cards: [
        {
          title: 'Interior Painting',
          description:
            'Clean, detailed interior paint services for rooms, ceilings, trims, and cabinets.',
          imageSrc: 'https://media.istockphoto.com/id/1461683093/photo/man-painting-wall-with-light-blue-dye-indoors-back-view.jpg?s=612x612&w=0&k=20&c=TDg87xVDJh-VA4zVClGlMnqpdqTh2QcZ--raihCv9XU=',
          imageAlt: 'Interior Painting',
        },
        {
          title: 'Exterior Painting',
          description:
            'Exterior finishes that enhance curb appeal and withstand the Indiana elements.',
          imageSrc: 'https://media.istockphoto.com/id/1250041313/photo/asian-painter-hanging-by-rope-for-fixing-and-painting-exterior.jpg?s=612x612&w=0&k=20&c=yaajywWds1VNqTKxuF5nGG64c-tsW2LpC2QHamwuIcs=',
          imageAlt: 'Exterior Painting',
        },
        {
          title: 'Drywall Repair & Staining',
          description:
            'We patch holes, fix drywall cracks, and offer staining for decks and wood surfaces.',
          imageSrc: 'https://media.istockphoto.com/id/1496455710/photo/ladder-and-construction-equipment-standing-in-empty-room-illuminated-by-bright-sunlight.jpg?s=612x612&w=0&k=20&c=AeNA_7UMoSyiBMfdsCcKeS-xc0rvBqB0JVn4a0hn65Y=',
          imageAlt: 'Drywall & Staining',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Cabinet Painting',
        'Fence & Deck Staining',
        'Drywall Patch & Repair',
        'Wall Priming',
        'Color Consultation',
        'Commercial Repaints',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/1309d5_3ff92adaa6244e14b65377a49ec0de7f~mv2.jpg/v1/fill/w_730,h_626,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/1309d5_3ff92adaa6244e14b65377a49ec0de7f~mv2.jpg',
        alt: "Javi's Painting Team at Work",
      },
      aboutText: [
        "Javi's Painting is a family-owned and operated painting business with over two decades of experience.",
        "We proudly serve Indianapolis and surrounding areas with dedication to quality, clean job sites, and customer-first service. Every coat we apply reflects our passion and professionalism.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Javi's Painting Logo",
      businessName: "Javi's Painting",
      contact: {
        phone: '5747039621',
        phoneLabel: '(574) 703-9621',
        email: 'espejo1983@gmail.com',
        website: 'https://www.javispainting.net/',
        address: 'Indianapolis, IN, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Indianapolis, IN, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98335.45619000427!2d-86.2771044581925!3d39.77940755346502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50b1738ad0a7%3A0x8a37ee3ebfc88d6a!2sIndianapolis%2C%20IN!5e0!3m2!1sen!2sus!4v1712114000000!5m2!1sen!2sus',
    },
  },
};

export default config;
